// import { useState, useEffect } from 'react';

// const MonthDropdown = ({getMonth, getYear}) => {
//   const currentYear = new Date().getFullYear();
//   const currentMonthIndex = new Date().getMonth(); // 0-11
  
//   const months = [
//     "January", "February", "March", "April", "May", "June",
//     "July", "August", "September", "October", "November", "December"
//   ];

//   // Set current month and year as default
//   const currentMonthAbbr = months[currentMonthIndex].slice(0, 3);
  
//   const [selectedMonth, setSelectedMonth] = useState(currentMonthAbbr); // Will be 'Jan', 'Feb', etc.
//   const [selectedYear, setSelectedYear] = useState(currentYear.toString());

//   // Call parent callbacks with initial values on mount
//   useEffect(() => {
//     getMonth(currentMonthAbbr);
//     getYear(currentYear.toString());
//   }, []);

//   const handleMonthYearChange = (e) => {
//     const value = e.target.value;
//     if (value === "0") {
//       setSelectedMonth('');
//       setSelectedYear('');
//       getMonth('');
//       getYear('');
//     } else {
//       const [month, year] = value.split('-');
//       setSelectedMonth(month); // 'Jan', 'Feb', etc.
//       getMonth(month);
//       setSelectedYear(year);
//       getYear(year);
//     }
//   };

//   return (
//     <div>
//       <select
//         name="monthYear"
//         id="monthYear"
//         className="custom-select-icon-left text-theme_clr1 text-base font-manrope font-semibold focus:outline-none w-full"
//         onChange={handleMonthYearChange}
//         value={selectedMonth && selectedYear ? `${selectedMonth}-${selectedYear}` : "0"}
//       >
//         <option value="0">Select Month</option>
//         {months.map((month, index) => {
//           const monthAbbr = month.slice(0, 3);
//           return (
//             <option 
//               key={index} 
//               value={`${monthAbbr}-${currentYear}`}
//             >
//               {monthAbbr} {currentYear}
//             </option>
//           );
//         })}
//       </select>

//       {/* CSS for limiting dropdown height */}
//       <style jsx>{`
//         select {
//           max-height: 200px;
//         }
//         select option {
//           padding: 8px;
//         }
//       `}</style>
//     </div>
//   );
// };

// export default MonthDropdown;

import { useState, useEffect } from 'react';

const MonthDropdown = ({getMonth, getYear}) => {
  const currentDate = new Date();
  const currentYear = currentDate.getFullYear();
  const currentMonthIndex = currentDate.getMonth(); // 0-11
  
  const months = [
    "January", "February", "March", "April", "May", "June",
    "July", "August", "September", "October", "November", "December"
  ];

  // Generate last 12 months including current month
  const generateLast12Months = () => {
    const monthsArray = [];
    
    for (let i = 0; i < 12; i++) {
      const date = new Date(currentYear, currentMonthIndex - i, 1);
      const monthIndex = date.getMonth();
      const year = date.getFullYear();
      const monthAbbr = months[monthIndex].slice(0, 3);
      
      monthsArray.push({
        monthAbbr,
        year: year.toString(),
        display: `${monthAbbr} ${year}`
      });
    }
    
    return monthsArray;
  };

  const last12Months = generateLast12Months();
  
  // Set current month and year as default
  const currentMonthAbbr = months[currentMonthIndex].slice(0, 3);
  
  const [selectedMonth, setSelectedMonth] = useState(currentMonthAbbr);
  const [selectedYear, setSelectedYear] = useState(currentYear.toString());

  // Call parent callbacks with initial values on mount
  useEffect(() => {
    getMonth(currentMonthAbbr);
    getYear(currentYear.toString());
  }, []);

  const handleMonthYearChange = (e) => {
    const value = e.target.value;
    if (value === "0") {
      setSelectedMonth('');
      setSelectedYear('');
      getMonth('');
      getYear('');
    } else {
      const [month, year] = value.split('-');
      setSelectedMonth(month);
      getMonth(month);
      setSelectedYear(year);
      getYear(year);
    }
  };

  return (
    <div>
      <select
        name="monthYear"
        id="monthYear"
        className="custom-select-icon-left text-theme_clr1 text-base font-manrope font-semibold focus:outline-none w-full"
        onChange={handleMonthYearChange}
        value={selectedMonth && selectedYear ? `${selectedMonth}-${selectedYear}` : "0"}
      >
        <option value="0">Select Month</option>
        {last12Months.map((item, index) => (
          <option 
            key={index} 
            value={`${item.monthAbbr}-${item.year}`}
          >
            {item.display}
          </option>
        ))}
      </select>

      {/* CSS for limiting dropdown height */}
      <style>{`
        select {
          max-height: 200px;
        }
        select option {
          padding: 8px;
        }
      `}</style>
    </div>
  );
};

export default MonthDropdown;